
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Products from './components/Products';
import WhyChooseUs from './components/WhyChooseUs';
import Industries from './components/Industries';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

export default function HomePage() {
  useScrollAnimation();

  const clientReviews = [
    {
      name: "Rajesh Kumar",
      position: "Project Director",
      company: "Delhi Metro Rail Corporation",
      review: "Lavin Enterprises has been our trusted partner for multiple metro projects. Their technical expertise in waterproofing solutions and timely delivery has been exceptional. The quality of their products and on-site support is unmatched.",
      rating: 5,
      project: "Delhi Metro Phase IV",
      image: "Professional Indian construction project director in formal attire at metro construction site, confident engineering professional with safety helmet, modern urban infrastructure background with metro construction equipment"
    },
    {
      name: "Dr. Priya Mehta",
      position: "Chief Engineer",
      company: "Godrej Properties",
      review: "Working with Lavin Enterprises for our residential projects has been a game-changer. Their comprehensive chemical solutions and technical guidance have helped us achieve superior quality in all our developments.",
      rating: 5,
      project: "Luxury Housing Complex",
      image: "Professional Indian female engineer in construction site, confident chief engineer with safety gear, modern residential building construction background with high-rise towers"
    },
    {
      name: "Amit Sharma",
      position: "Operations Manager",
      company: "Tata Steel Construction",
      review: "The industrial flooring solutions provided by Lavin Enterprises for our manufacturing facility exceeded our expectations. Their chemical-resistant coatings have proven highly durable under extreme industrial conditions.",
      rating: 5,
      project: "Industrial Manufacturing Plant",
      image: "Professional Indian operations manager in industrial setting, experienced manufacturing professional with safety equipment, modern industrial facility background with steel structures"
    },
    {
      name: "Suresh Patel",
      position: "Site Engineer",
      company: "L&T Construction",
      review: "Lavin's technical support team is outstanding. They provided on-ground assistance throughout our bridge construction project, ensuring proper application and long-term durability of their chemical solutions.",
      rating: 5,
      project: "Highway Bridge Construction",
      image: "Professional Indian site engineer at bridge construction project, experienced civil engineer with construction plans, large bridge infrastructure background with construction machinery"
    },
    {
      name: "Kavita Singh",
      position: "Quality Manager",
      company: "UltraTech RMC",
      review: "As an RMC plant, we rely on consistent quality admixtures. Lavin Enterprises has been our reliable partner, providing superior concrete admixtures that enhance our product performance significantly.",
      rating: 5,
      project: "Ready Mix Concrete Supply",
      image: "Professional Indian quality manager at concrete plant facility, experienced quality control professional with testing equipment, modern RMC plant background with concrete mixing trucks"
    },
    {
      name: "Vikram Joshi",
      position: "Project Head",
      company: "Airport Authority of India",
      review: "For our airport terminal expansion, Lavin Enterprises delivered comprehensive chemical solutions on time and within budget. Their expertise in large-scale infrastructure projects is truly commendable.",
      rating: 5,
      project: "Airport Terminal Expansion",
      image: "Professional Indian project head at airport construction site, confident aviation infrastructure professional with safety vest, modern airport terminal construction background with glass architecture"
    }
  ];

  return (
    <div className="min-h-screen relative">
      <Header />
      <Hero />
      <div className="scroll-animate">
        <About />
      </div>
      <div className="scroll-animate">
        <Services />
      </div>
      <div className="scroll-animate">
        <Products />
      </div>
      <div className="scroll-animate">
        <WhyChooseUs />
      </div>
      <div className="scroll-animate">
        <Industries />
      </div>
      
      {/* Client Reviews Section */}
      <div className="scroll-animate">
        <section className="py-20 bg-gray-50">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-16">
                <h2 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#45524A' }}>
                  What Our Clients Say
                </h2>
                <p className="text-xl text-gray-600 leading-relaxed max-w-4xl mx-auto">
                  Trusted by industry leaders across India, our commitment to excellence and technical expertise 
                  has earned us lasting partnerships and outstanding client satisfaction.
                </p>
              </div>

              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                {clientReviews.map((review, index) => (
                  <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
                    <div className="flex items-center mb-6">
                      <div className="w-16 h-16 rounded-full overflow-hidden mr-4 flex-shrink-0">
                        <img 
                          src={`https://readdy.ai/api/search-image?query=$%7Breview.image%7D&width=150&height=150&seq=client-${index}&orientation=squarish`}
                          alt={review.name}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <div>
                        <h3 className="text-lg font-bold text-gray-800">{review.name}</h3>
                        <p className="text-sm text-gray-600">{review.position}</p>
                        <p className="text-sm font-medium" style={{ color: '#45524A' }}>{review.company}</p>
                      </div>
                    </div>

                    <div className="flex mb-4">
                      {[...Array(review.rating)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                      ))}
                    </div>

                    <p className="text-gray-700 leading-relaxed mb-4 italic">
                      "{review.review}"
                    </p>

                    <div className="border-t pt-4">
                      <div className="flex items-center text-sm text-gray-500">
                        <i className="ri-building-line mr-2"></i>
                        <span>{review.project}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Trust Indicators */}
              <div className="mt-16 bg-white rounded-2xl p-8 md:p-12 shadow-lg">
                <div className="grid md:grid-cols-4 gap-8 text-center">
                  <div>
                    <div className="text-4xl font-bold mb-2" style={{ color: '#45524A' }}>99.8%</div>
                    <div className="text-gray-600">Client Satisfaction</div>
                  </div>
                  <div>
                    <div className="text-4xl font-bold mb-2" style={{ color: '#45524A' }}>500+</div>
                    <div className="text-gray-600">Successful Projects</div>
                  </div>
                  <div>
                    <div className="text-4xl font-bold mb-2" style={{ color: '#45524A' }}>200+</div>
                    <div className="text-gray-600">Happy Clients</div>
                  </div>
                  <div>
                    <div className="text-4xl font-bold mb-2" style={{ color: '#45524A' }}>25+</div>
                    <div className="text-gray-600">Years Experience</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div className="scroll-animate">
        <Contact />
      </div>
      <Footer />
    </div>
  );
}
